import { Logger, LoggerService } from '@Shared/logger';
import { Screen } from './screen.base';
import { OptionsModule } from '@Modules/options_module';
import { UIModule } from '@Modules/ui_module/ui.module';
import { Alert } from '@Modules/ui_module/components/alert/alert.component';

export class ProcessNewStartScreen extends Screen {
  private Logger: Logger = LoggerService.createLogger('ProcessNewStartScreen');

  constructor() {
    super();
    this.Logger.trace('****  CTOR ****');

    this._html = UIModule.HTML.processNewStart;
    this._screenOptions = OptionsModule.Options.ui.screens.processNewStart;
    this._alert = new Alert();
  }

  show(): void {
    super.show();
    this.Logger.trace('show called');
  }
}
